var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"account"},[_c('header',[_c('BannerLegal'),_c('Navbar')],1),_c('div',{class:_vm.containerClasses},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }